export default __webpack_public_path__ + "assets/67a411a11f0f822af00144f6f3cddf81.png";